import { Link, useParams } from "react-router-dom";
import { Avatar, Table } from "flowbite-react"
import { MdVerified } from "react-icons/md";
import DateFormatter from "../dates/DateFormatter";

const InfluencerRow = ({ lookalike }) => {
  const { id } = useParams();

  if (!lookalike || !lookalike.modashInfluencer) return null;

  const {
    modashInfluencer: {
      userId,
      profile: { username, picture, fullname, isVerified },
    },
    status,
    updatedAt,
    _id,
    campaignId,
    campaign
  } = lookalike;

  return (
    <Table.Row className="bg-white" key={userId}>
      <Table.Cell>
        <Link
          to={`/campaigns/${campaignId ? campaignId : id}/${_id}`}
          className="flex gap-4 items-center"
        >
          <Avatar img={picture} rounded />
          <div>
            <div className="text-gray-900 flex gap-1 items-center">
              {fullname}
              {isVerified && <MdVerified className="text-blue-500" />}
            </div>
            <div className="text-xs mt-1">@{username}</div>
          </div>
          {campaign?.name ? campaign.name : ''}
        </Link>
      </Table.Cell>
      <Table.Cell>{status || "Unknown Status"}</Table.Cell>
      <Table.Cell>
        <DateFormatter date={updatedAt} />
      </Table.Cell>
    </Table.Row>
  );
}

export default InfluencerRow;
